module.exports = __webpack_public_path__ + "resources/img/bookimg@3x.ebc5899d.png";